"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderSent = void 0;
var constants_1 = require("../constants");
var getOrderProps = function (_a) {
    var _b;
    var cart = _a.cart, session = _a.session;
    return (_b = {},
        _b[constants_1.EventProperty.CART_PRODUCT_CATEGORIES] = cart.categories,
        _b[constants_1.EventProperty.CART_PRODUCT_IDS] = cart.ids,
        _b[constants_1.EventProperty.CART_PRODUCT_NAMES] = cart.names,
        _b[constants_1.EventProperty.CART_PRODUCT_SKUS] = cart.skus,
        _b[constants_1.EventProperty.CART_SIZE] = cart.size,
        _b[constants_1.EventProperty.CART_VALUE] = cart.value,
        _b[constants_1.EventProperty.CUSTOM_NOTE_TEXT] = cart.note,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b);
};
exports.orderSent = function (_a) {
    var cart = _a.cart, session = _a.session;
    var props = getOrderProps({ cart: cart, session: session });
    window.analytics.track(constants_1.EventName.ORDER_SENT, props);
};
